// extracted by mini-css-extract-plugin
export var blue = "_1m-f";
export var brand = "_1m-b";
export var darkGrey = "_1m-e";
export var disabled = "_1m-4";
export var disabledSubtle = "_1m-5";
export var error = "_1m-6";
export var green = "_1m-g";
export var grey = "_1m-d";
export var icon = "_1m-0";
export var inherit = "_1m-a";
export var lightGrey = "_1m-c";
export var orange = "_1m-i";
export var pink = "_1m-k";
export var primary = "_1m-1";
export var purple = "_1m-l";
export var red = "_1m-j";
export var secondary = "_1m-2";
export var success = "_1m-9";
export var tertiary = "_1m-3";
export var warning = "_1m-7";
export var warningSecondary = "_1m-8";
export var white = "_1m-m";
export var yellow = "_1m-h";